import { Chip } from "@mui/material";

export const COLUMNSLICENCIAS = [
  {
    header: "Legajo",
    accessorKey: "legajo",
    size: 50,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Nombre empleado",
    accessorKey: "nombreEmpleado",
    size: 140,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
];

export const COLUMNSLICENCIASINGRESADAS = [
  {
    accessorKey: "id",
  },
  {
    header: "Licencias Solicitadas",
    accessorKey: "new_name",
    size: 140,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Días Solicitados",
    accessorKey: "diasSolicitados",
    size: 80,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Fecha Desde",
    accessorKey: "new_fechadesde",
    size: 80,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Fecha Hasta",
    accessorKey: "new_fechahasta",
    size: 80,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Estado",
    accessorKey: "statuscode",
    size: 100,
    Cell: ({ cell }) => {
      switch (cell.getValue()) {
        case 100000000:
          return (
            <Chip
              label="Aprobada"
              sx={{ fontWeight: "bold" }}
              color="success"
              variant="outlined"
            />
          );
        case 100000001:
          return (
            <Chip
              label="No aprobada"
              sx={{ fontWeight: "bold" }}
              color="error"
              variant="outlined"
            />
          );
        case 100000002:
          return (
            <Chip
              label="Cancelada"
              sx={{ fontWeight: "bold" }}
              color="error"
              variant="outlined"
            />
          );
        case 100000003:
          return (
            <Chip
              label="Gozada"
              sx={{ fontWeight: "bold" }}
              color="success"
              variant="outlined"
            />
          );
          case 100000004:
            return (
              <Chip
                label="Vigente"
                sx={{ fontWeight: "bold" }}
                color="success"
                variant="outlined"
              />
            );
          case 100000005:
            return (
              <Chip
                label="Requiere Más Información"
                sx={{ fontWeight: "bold" }}
                color="warning"
                variant="outlined"
              />
            );
        case 1:
          return (
            <Chip
              label="Solicitada"
              sx={{ fontWeight: "bold" }}
              color="info"
              variant="outlined"
            />
          );
      }
    },
  },
];

export const COLUMNSLICENCIASAPROBADAS = [
  {
    accessorKey: "id",
  },
  {
    header: "Licencias Solicitadas",
    accessorKey: "new_name",
    size: 140,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Días Solicitados",
    accessorKey: "diasSolicitados",
    size: 80,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Fecha Desde",
    accessorKey: "new_fechadesde",
    size: 80,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Fecha Hasta",
    accessorKey: "new_fechahasta",
    size: 80,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Estado",
    accessorKey: "statuscode",
    size: 100,
    Cell: ({ cell }) => {
      switch (cell.getValue()) {
        case 100000000:
          return (
            <Chip
              label="Aprobada"
              sx={{ fontWeight: "bold" }}
              color="success"
              variant="outlined"
            />
          );
        case 100000001:
          return (
            <Chip
              label="No aprobada"
              sx={{ fontWeight: "bold" }}
              color="error"
              variant="outlined"
            />
          );
        case 100000002:
          return (
            <Chip
              label="Cancelada"
              sx={{ fontWeight: "bold" }}
              color="error"
              variant="outlined"
            />
          );
        case 100000003:
          return (
            <Chip
              label="Gozada"
              sx={{ fontWeight: "bold" }}
              color="success"
              variant="outlined"
            />
          );
          case 100000004:
            return (
              <Chip
                label="Vigente"
                sx={{ fontWeight: "bold" }}
                color="success"
                variant="outlined"
              />
            );
          case 100000005:
            return (
              <Chip
                label="Requiere Más Información"
                sx={{ fontWeight: "bold" }}
                color="warning"
                variant="outlined"
              />
            );
        case 1:
          return (
            <Chip
              label="Solicitada"
              sx={{ fontWeight: "bold" }}
              color="info"
              variant="outlined"
            />
          );
      }
    },
  },
];

export const COLUMNSNOADMITIDAS = [
  {
    accessorKey: "id",
  },
  {
    header: "Licencias Solicitadas",
    accessorKey: "new_name",
    size: 140,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Días Solicitados",
    accessorKey: "diasSolicitados",
    size: 80,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Fecha Desde",
    accessorKey: "new_fechadesde",
    size: 80,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Fecha Hasta",
    accessorKey: "new_fechahasta",
    size: 80,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Estado",
    accessorKey: "statuscode",
    size: 100,
    Cell: ({ cell }) => {
      switch (cell.getValue()) {
        case 100000000:
          return (
            <Chip
              label="Aprobada"
              sx={{ fontWeight: "bold" }}
              color="success"
              variant="outlined"
            />
          );
        case 100000001:
          return (
            <Chip
              label="No aprobada"
              sx={{ fontWeight: "bold" }}
              color="error"
              variant="outlined"
            />
          );
        case 100000002:
          return (
            <Chip
              label="Cancelada"
              sx={{ fontWeight: "bold" }}
              color="error"
              variant="outlined"
            />
          );
        case 100000003:
          return (
            <Chip
              label="Gozada"
              sx={{ fontWeight: "bold" }}
              color="success"
              variant="outlined"
            />
          );
          case 100000004:
            return (
              <Chip
                label="Vigente"
                sx={{ fontWeight: "bold" }}
                color="success"
                variant="outlined"
              />
            );
          case 100000005:
            return (
              <Chip
                label="Requiere Más Información"
                sx={{ fontWeight: "bold" }}
                color="warning"
                variant="outlined"
              />
            );
        case 1:
          return (
            <Chip
              label="Solicitada"
              sx={{ fontWeight: "bold" }}
              color="info"
              variant="outlined"
            />
          );
      }
    },
  },
];

export const COLUMNSINGRESADASEQUIPO = [
  {
    accessorKey: "id",
  },
  {
    header: "Licencias Solicitadas",
    accessorKey: "new_name",
    size: 140,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Días Solicitados",
    accessorKey: "diasSolicitados",
    size: 80,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Fecha Desde",
    accessorKey: "new_fechadesde",
    size: 80,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Fecha Hasta",
    accessorKey: "new_fechahasta",
    size: 80,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Estado",
    accessorKey: "statuscode",
    size: 100,
    Cell: ({ cell }) => {
      switch (cell.getValue()) {
        case 100000000:
          return (
            <Chip
              label="Aprobada"
              sx={{ fontWeight: "bold" }}
              color="success"
              variant="outlined"
            />
          );
        case 100000001:
          return (
            <Chip
              label="No aprobada"
              sx={{ fontWeight: "bold" }}
              color="error"
              variant="outlined"
            />
          );
        case 100000002:
          return (
            <Chip
              label="Cancelada"
              sx={{ fontWeight: "bold" }}
              color="error"
              variant="outlined"
            />
          );
        case 100000003:
          return (
            <Chip
              label="Gozada"
              sx={{ fontWeight: "bold" }}
              color="success"
              variant="outlined"
            />
          );
          case 100000004:
            return (
              <Chip
                label="Vigente"
                sx={{ fontWeight: "bold" }}
                color="success"
                variant="outlined"
              />
            );
          case 100000005:
            return (
              <Chip
                label="Requiere Más Información"
                sx={{ fontWeight: "bold" }}
                color="warning"
                variant="outlined"
              />
            );
        case 1:
          return (
            <Chip
              label="Solicitada"
              sx={{ fontWeight: "bold" }}
              color="info"
              variant="outlined"
            />
          );
      }
    },
  },
];

export const COLUMNSAPROBADASEQUIPO = [
  {
    accessorKey: "id",
  },
  {
    header: "Licencias Solicitadas",
    accessorKey: "new_name",
    size: 140,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Días Solicitados",
    accessorKey: "diasSolicitados",
    size: 80,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Fecha Desde",
    accessorKey: "new_fechadesde",
    size: 80,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Fecha Hasta",
    accessorKey: "new_fechahasta",
    size: 80,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Estado",
    accessorKey: "statuscode",
    size: 100,
    Cell: ({ cell }) => {
      switch (cell.getValue()) {
        case 100000000:
          return (
            <Chip
              label="Aprobada"
              sx={{ fontWeight: "bold" }}
              color="success"
              variant="outlined"
            />
          );
        case 100000001:
          return (
            <Chip
              label="No aprobada"
              sx={{ fontWeight: "bold" }}
              color="error"
              variant="outlined"
            />
          );
        case 100000002:
          return (
            <Chip
              label="Cancelada"
              sx={{ fontWeight: "bold" }}
              color="error"
              variant="outlined"
            />
          );
        case 100000003:
          return (
            <Chip
              label="Gozada"
              sx={{ fontWeight: "bold" }}
              color="success"
              variant="outlined"
            />
          );
          case 100000004:
            return (
              <Chip
                label="Vigente"
                sx={{ fontWeight: "bold" }}
                color="success"
                variant="outlined"
              />
            );
          case 100000005:
            return (
              <Chip
                label="Requiere Más Información"
                sx={{ fontWeight: "bold" }}
                color="warning"
                variant="outlined"
              />
            );
        case 1:
          return (
            <Chip
              label="Solicitada"
              sx={{ fontWeight: "bold" }}
              color="info"
              variant="outlined"
            />
          );
      }
    },
  },
];

export const COLUMNSNOAPROBADASEQUIPO = [
  {
    accessorKey: "id",
  },
  {
    header: "Licencias Solicitadas",
    accessorKey: "new_name",
    size: 140,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Días Solicitados",
    accessorKey: "diasSolicitados",
    size: 80,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Fecha Desde",
    accessorKey: "new_fechadesde",
    size: 80,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Fecha Hasta",
    accessorKey: "new_fechahasta",
    size: 80,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Estado",
    accessorKey: "statuscode",
    size: 100,
    Cell: ({ cell }) => {
      switch (cell.getValue()) {
        case 100000000:
          return (
            <Chip
              label="Aprobada"
              sx={{ fontWeight: "bold" }}
              color="success"
              variant="outlined"
            />
          );
        case 100000001:
          return (
            <Chip
              label="No aprobada"
              sx={{ fontWeight: "bold" }}
              color="error"
              variant="outlined"
            />
          );
        case 100000002:
          return (
            <Chip
              label="Cancelada"
              sx={{ fontWeight: "bold" }}
              color="error"
              variant="outlined"
            />
          );
        case 100000003:
          return (
            <Chip
              label="Gozada"
              sx={{ fontWeight: "bold" }}
              color="success"
              variant="outlined"
            />
          );
          case 100000004:
            return (
              <Chip
                label="Vigente"
                sx={{ fontWeight: "bold" }}
                color="success"
                variant="outlined"
              />
            );
          case 100000005:
            return (
              <Chip
                label="Requiere Más Información"
                sx={{ fontWeight: "bold" }}
                color="warning"
                variant="outlined"
              />
            );
        case 1:
          return (
            <Chip
              label="Solicitada"
              sx={{ fontWeight: "bold" }}
              color="info"
              variant="outlined"
            />
          );
      }
    },
  },
];
